var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex w-full bg-img"},[_c('div',{staticClass:"vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"},[_c('h1',{staticClass:"sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color"},[_vm._v("Logging out...")])])])
}]

export { render, staticRenderFns }